import React from 'react';

import { Avatar, createStyles, Stack, Text, Paper, Flex } from '@mantine/core';
import dayjs, { Dayjs } from 'dayjs';
import { StaffWithProfilePicture } from 'types';

const useStyles = createStyles(() => ({
  container: {
    width: '100%',
    margin: '0 auto',
    padding: '0 10%',
  },
  avatar: {
    position: 'relative',
    left: 16,
  },
  coach: {
    width: 'inherit',
    backgroundColor: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
  },
}));

const HeaderSection = ({
  fullStartDate,
  duration,
  eventCoachEventCoachRoles,
}: {
  fullStartDate: Dayjs;
  duration: number;
  eventCoachEventCoachRoles: {
    coach: StaffWithProfilePicture;
    role: string;
  }[];
}): JSX.Element => {
  const { classes } = useStyles();
  return (
    <Stack spacing='xs'>
      <Stack spacing={0}>
        <Text align='center' size='lg' weight='bold' color='gray.8'>
          {dayjs(fullStartDate).format('dddd, MMMM D')}
        </Text>
        <Text align='center' size='lg' weight='bold' color='gray.8'>
          {`${fullStartDate.format('h:mma')} - ${fullStartDate.add(duration, 'minutes').format('h:mma')}`}
        </Text>
      </Stack>

      {eventCoachEventCoachRoles.length > 0 &&
        eventCoachEventCoachRoles.map((ececr, i) => (
          <Flex key={i} align='center' gap={0} className={classes.container}>
            <Avatar
              src={ececr.coach.profilePicture}
              alt='profile picture'
              color='kiloBlue'
              radius={160}
              size={120}
              className={classes.avatar}
            />
            <Paper p='xs' pl='2rem' radius='md' className={classes.coach}>
              <Text weight='bold' size='lg' color='gray.7'>
                {ececr.coach.fullName}
              </Text>
              <Text size='sm' color='dimmed'>
                {ececr.role}
              </Text>
            </Paper>
          </Flex>
        ))}
    </Stack>
  );
};

export default HeaderSection;
